<div class="relative w-full lg:w-auto flex items-center justify-center  space-x-4">
  @if (isAuthenticated) {
  <!-- Usuario Autenticado -->
  <div class="relative">
    <button (click)="toggleMenu()"
      class="flex items-center space-x-3 p-2 rounded-lg bg-menu bg-menu-hover transition-colors text-white">
      <!-- Avatar -->
      <div class="w-10 h-10 bg-avatar rounded-full flex items-center justify-center text-white font-semibold">
        {{ getInitials(user!.name) }}
      </div>

      <!-- Nombre -->
      <!-- <div class="hidden md:block text-left">
        <p class="text-sm font-medium text-white">{{ user!.name }}</p>
        <p class="text-xs text-purple-200">{{ user!.email }}</p>
      </div> -->

      <!-- Icono -->
      <svg class="w-5 h-5 text-neutral-400 transform transition-transform duration-200" [class.rotate-180]="isOpen()"
        fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
      </svg>
    </button>

    <!-- Dropdown Menu -->
    @if (isOpen()) {
    <div class="absolute right-0 mt-2 w-56 rounded-lg shadow-lg border z-50 bg-menu text-white border-white/10">
      <div class="p-4 border-b border-gray-200">
        <p class="text-sm font-medium text-white">{{ user!.name }}</p>
        <p class="text-xs text-purple-200">{{ user!.email }}</p>
        <p class="text-xs text-purple-200">Doc: {{ user!.documentNumber }}</p>
      </div>

      <div class="py-2">
        <a routerLink="/auth/profile" (click)="handleLinkClick()"
          class="w-full text-left px-4 py-2 text-sm hover:bg-menu-hover transition-colors flex items-center text-white">
          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
          </svg>
          Mi Perfil
        </a>

        <hr class="my-2">

        <button (click)="onLogout()"
          class="w-full text-left px-4 py-2 text-sm text-red-300 hover:bg-red-700/20 transition-colors flex items-center">
          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
          </svg>
          Cerrar Sesión
        </button>
      </div>
    </div>
    }
  </div>
  } @else {
  <!-- Usuario No Autenticado -->
  <button (click)="onLogin()"
    class="btn-login mt-4 lg:m-0 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center space-x-2">
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
    </svg>
    <span>Iniciar Sesión</span>
  </button>
  }
</div>

<!-- Overlay para cerrar el menú -->
@if (isOpen()) {
<div class="fixed inset-0 z-40" (click)="closeMenu()"></div>
}